/**
 * Distingue plain objects (`{}`, `Object.create(null)`) da istanze
 * di classi (Date, File, Map, classi custom, ecc.).
 *
 * Usata in `syncComputedValues` per decidere se ricorrere in un
 * oggetto (strutturale) o scriverlo come valore foglia, e in
 * `assertNoCustomInstances` per identificare oggetti non serializzabili.
 */
export function isPlainObject(value: unknown): boolean {
  if (value == null || typeof value !== 'object') return false;
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
}

/**
 * Valore foglia compatibile con `structuredClone`: primitivi,
 * Date, File, Blob. Tutti gli altri oggetti (plain o meno)
 * richiedono ispezione ulteriore (ricorsione o warning).
 *
 * Usata in `syncComputedValues` per escludere Date/File/Blob
 * dalla ricorsione, e in `assertNoCustomInstances` come allowlist
 * per `structuredClone`.
 */
export function isSerializableLeaf(value: unknown): boolean {
  if (value === null || typeof value !== 'object') return true;
  if (value instanceof Date) return true;
  if (value instanceof File || value instanceof Blob) return true;
  return false;
}
